<template>
    <div class="co-email-contato">
        <v-text-field
            v-model="value.email"
            v-validate="validarCampo()"
            :class="campoRequerido ? 'required-field' : ''"
            :disabled="desabilitarCampo"
            :error-messages="errors.collect('E-mail')"
            :label="placeholder"
            name="E-mail"
            :placeholder="placeholder"
            persistent-placeholder
        />

        <div v-if="descricao" class="hint-checkbox">
            {{ descricaoCampo }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmailContato',
    props: {
        value: {
            required: true
        },
        campoRequerido: {
            type: Boolean,
            default: false
        },
        desabilitarCampo: {
            type: Boolean
        },
        descricao: {
            type: Boolean
        },
    },
    data() {
        return {
            descricaoCampo: `Forma de comunicação entre as duas partes (Organização e Usuário)`
        }
    },
    computed: {
        placeholder() {
            return `E-mail do usuário`
        }
    },
    methods: {
        validarCampo() {
            return this.campoRequerido ? 'required|email' : ''
        }
    }
}
</script>